var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M0.146483 0.849942L4.14844 4.85346C4.3418 5.04689 4.6582 5.04689 4.85742 4.85346L8.85352 0.849943C9.04688 0.656508 9.04688 0.339978 8.85352 0.140682C8.66016 -0.0527535 8.34375 -0.0527535 8.14453 0.140682L4.5 3.78664L0.855468 0.146542C0.755859 0.0468943 0.626953 6.98644e-07 0.503905 6.87887e-07C0.374999 6.76618e-07 0.246092 0.0468943 0.152342 0.146542C-0.0468765 0.339977 -0.0468765 0.656507 0.146483 0.849942Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"9","height":"5","fill":"white","transform":"translate(9 5) rotate(-180)"})))]);
}

ChevronInline.defaultProps = {"width":"9","height":"5","viewBox":"0 0 9 5","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
